import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { capitalizeWord } from 'utils/strings/string.utils';
import {
  formatStormCoordinate,
  formatStormPressure,
  formatStormWindSpeed,
} from '../utils/hurricanes.utils';

export const hurricaneDetails = [
  {
    id: 'type',
    label: 'Type',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HURRICANE,
    getValue: (record) => capitalizeWord(record?.type ?? '') || '--',
  },
  {
    id: 'date',
    label: 'Date',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DATE,
    getValue: (record) => record?.locale_time ?? '--',
  },
  {
    id: 'category',
    label: 'Category',
    iconKey: WEATHER_DETAIL_ICON_KEYS.CATEGORY,
    getValue: (record) => record?.category ?? '--',
  },
  {
    id: 'windSpeed',
    label: 'Max Wind Speed',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (record) => formatStormWindSpeed(record?.wind_speed),
  },
  {
    id: 'latitude',
    label: 'Latitude',
    iconKey: WEATHER_DETAIL_ICON_KEYS.LOCATION,
    getValue: (record) => formatStormCoordinate(record?.latitude),
  },
  {
    id: 'longitude',
    label: 'Longitude',
    iconKey: WEATHER_DETAIL_ICON_KEYS.LOCATION,
    getValue: (record) => formatStormCoordinate(record?.longitude),
  },
  {
    id: 'pressure',
    label: 'Baro Pressure',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRESSURE,
    getValue: (record) => formatStormPressure(record?.central_pressure),
  },
];

export const hurricaneDetailGroups = [
  ['type', 'category'],
  ['windSpeed', 'pressure'],
  ['date'],
  ['latitude', 'longitude'],
];
